import { ErrorReportingClient } from '../types/ErrorReportingClient';
import { ErrorReportingDevtools } from '../types/ErrorReportingDevtools';

/**
 * Resets the per-session scope so subsequent events do not carry over
 * user, tags, extras, or breadcrumbs from earlier QA actions.
 */
export const createClearScopeDevtool = (
  client: ErrorReportingClient,
): ErrorReportingDevtools['clearScope'] => {
  return (): void => {
    client.clearScope();
  };
};
